<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('settings.lov_original_brands.form.name')"
            :is-required="true"
            :hint="__('settings.lov_original_brands.form.name_hint')"
        >
            <DInput
                id="paymentTerm"
                v-model="form.name"
                :placeholder="__('settings.lov_original_brands.form.name')"
                add-input-classes="bg-light"
                :is-valid="isFormFieldValid('name')"
                :invalid-feedback="errors.name"
                maxlength="45"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.lov_original_brands.form.status')"
            :is-required="true"
            :error="errors.status"
            :hint="__('settings.lov_original_brands.form.status_hint')"
        >
            <DSwitch
                id="switch-status"
                v-model="form.status"
                color="success"
                variant="3d"
            />
        </DFormRow>
        <DFormControls
            :cancel-route="$route('settings.original-brands.index')"
            :dirty="form.isDirty"
            @submit="submitForm"
        />
    </DForm>
</template>

<script setup>
import { useForm } from '@inertiajs/vue3'

const props = defineProps({
    originalBrand: {
        type: Object,
        default: () => { return {} }
    },
    errors: {
        type: Object,
        default: () => { return {} }
    }
})

const form = useForm({
    id: props.originalBrand?.id ?? null,
    name: props.originalBrand?.name ?? null,
    status: props.originalBrand?.status ?? null
})

const emit = defineEmits(['form-submitted'])
function submitForm () {
    emit('form-submitted', form)
}

</script>
